export default __webpack_public_path__ + "static/media/slider-Arrow-Left.7e95b6d6.svg";